export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_combineName') || 'SKU名称',
    field: 'combineName',
    minWidth: 300,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_combineColor') || '产品颜色',
    field: 'combineColor',
    minWidth: 240,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayColor' },
  },
  {
    title: that.$l('table_label_combineSize') || '产品尺寸',
    field: 'combineSize',
    minWidth: 180,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_ftyPrice') || '工厂单价',
    field: 'ftyPrice',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'ftyPrice' },
  },
  {
    title: that.$l('table_label_inCombineQty') || '组合内数量',
    field: 'inCombineQty',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 1,
        step: 1,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_isPrimary') || '是否主产品',
    field: 'isPrimaryText',
    minWidth: 200,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    editRender: { enabled: true },
    slots: { edit: 'primary' },
  },
]
